import { InitialPackageType } from "../../enums/index";
function GetInitialPackageText(type) {
  let result = "";
  switch (type) {
    case InitialPackageType.SeparateFromPackage():
      result = "جدا از بسته";
      break;
    case InitialPackageType.Secretary():
      result = "منشی";
      break;
    case InitialPackageType.IVR():
      result = "تلفن گویا";
      break;
    case InitialPackageType.Fax():
      result = "فکس";
      break;
    default:
      result = "";
      break;
  }
  return result;
}
export default GetInitialPackageText;
